import Select from '@ui-library/select';
import React, { useEffect, useState } from 'react';
import { WAREHOUSE_DOC_LINKS } from '../../../../source/warehouseSource/warehouseSourceList/warehouseSettings';
import DocLinkLabel from '../../../../docLinksLabel';

export interface ISyncBehaviourProps {
  isViewOrUpdate?: boolean;
  currentMode?: string;
  setSyncBehaviour: (mode: string) => void;
}

export interface SyncBehaviourSelectOptionProps {
  value: string;
  label: string;
}

interface ISyncBehaviourSelectProps extends ISyncBehaviourProps {
  syncBehaviourOptions: SyncBehaviourSelectOptionProps[];
}

const SyncBehaviourSelect = ({
  syncBehaviourOptions,
  isViewOrUpdate,
  currentMode,
  setSyncBehaviour,
}: ISyncBehaviourSelectProps) => {
  const defaultSyncMode = syncBehaviourOptions?.length ? syncBehaviourOptions[0] : undefined;
  const modeDetails =
    syncBehaviourOptions?.find(
      (curr: SyncBehaviourSelectOptionProps) => currentMode === curr.value,
    ) || defaultSyncMode;
  const [selectedMode, setMode] = useState<SyncBehaviourSelectOptionProps | undefined>(modeDetails);
  useEffect(() => {
    setSyncBehaviour(selectedMode?.value || '');
  }, [selectedMode]);

  return (
    <>
      <Select
        label="Sync mode"
        required
        labelInValue
        disabled={isViewOrUpdate}
        value={selectedMode}
        onChange={setMode}
        options={syncBehaviourOptions || []}
      />
      <DocLinkLabel
        description={`The operation to perform on destination for
        each record during sync. For more information visit`}
        linkRef={WAREHOUSE_DOC_LINKS.syncModes}
        linkText="Sync Modes"
      />
    </>
  );
};
export default SyncBehaviourSelect;
